import { Drawer } from 'antd';
import { useContext } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { TaskCenterContext } from 'app/context/TaskCenterContext/TaskCenterContext';
import { useGetBookingDetailByCode } from 'app/hooks/data/extranet/bookings/useBooking';
import { useMoveZendesk } from 'app/hooks/useZendeskWidget/useMoveZendesk';
import { dateAndHour } from 'app/utils/dates';

import { BookingDetailSection } from '../common/BookingDetailSection/BookingDetailSection';
import { Help } from '../common/Help/Help';

import './BookingDetail.scss';
import { BookingDetailHeader } from './_components/BookingDetailHeader/BookingDetailHeader';
import { BookingInfo } from './_components/BookingInfo/BookingInfo';
import { PaymentDetails } from './_components/PaymentDetails/PaymentDetails';
import { LegacyVirtualCard } from './_components/VirtualCard/VirtualCard';

type BookingDetailProps = {
  bookingCode?: string;
  scrollVCC: boolean;
  onClose: () => void;
};

export const BookingDetail = ({
  bookingCode,
  scrollVCC,
  onClose,
}: BookingDetailProps) => {
  const { hotelId } = useContext(HotelContext);
  const { data: bookingData, isLoading: bookingIsLoading } =
    useGetBookingDetailByCode(hotelId, bookingCode);
  const { isTaskCenterOpen } = useContext(TaskCenterContext);

  useMoveZendesk({
    moveZendesk: true,
    drawerOpen: (!!bookingCode && !!hotelId) || isTaskCenterOpen,
  });

  if (!bookingData || bookingIsLoading) {
    return <></>;
  }

  return (
    <Drawer
      title={
        <div className="booking-detail-title">
          <div className="customer-info">
            {[
              `${bookingData.booking.customer.gender}.`,
              bookingData.booking.customer.firstName,
              bookingData.booking.customer.lastName,
            ].join(' ')}
          </div>
          <div className="booking-info">
            Booking date : {dateAndHour(bookingData.booking.payedAt)}
          </div>
        </div>
      }
      className="booking-detail"
      open={!!bookingCode && !!hotelId}
      onClose={onClose}
      width={510}
      destroyOnClose
      bodyStyle={{ padding: 0 }}
    >
      <div className="booking-detail-container">
        <BookingDetailHeader
          booking={bookingData.booking}
          scrollVCC={scrollVCC}
        />
        <div className="booking-detail-content">
          <BookingDetailSection title="Booking" name="booking">
            <BookingInfo booking={bookingData.booking} />
          </BookingDetailSection>
          <BookingDetailSection title="Payment Details" name="payment-details">
            <PaymentDetails booking={bookingData.booking} />
          </BookingDetailSection>
          {bookingData.booking.issuingCardId && (
            <>
              <BookingDetailSection title="Virtual Card" name="virtual-card">
                <LegacyVirtualCard booking={bookingData.booking} />
              </BookingDetailSection>
              <BookingDetailSection title="Help" name="help">
                <Help />
              </BookingDetailSection>
            </>
          )}
        </div>
      </div>
    </Drawer>
  );
};
